<template>
    <div class="main">
        <div>

        </div>
        <div class="main_footer">
            <div class="footer_btn">绑定电子合同</div>
        </div>
    </div>
</template>
<script>
     import qs from 'qs';
    export default {
        data () {
            return {
                id:this.$route.id,
                token:this.$route.token
            }
        },
        created(){
            console.log(this.$route.id);
            this.getDetial();
        },
        methods:{
            
            getDetial(){
                const data=qs.stringify({'token':this.token});
                let config = {
                    headers: {
                        // 添加请求头
                        'Content-Type': 'application/x-www-form-urlencoded',
                        baseURL:process.env.VUE_COMPANY_UTL
                    }
                };
                this.axios.post('companyTio/contract/office/#/contractDetail/'+this.id,data,config)
                        .then(res => {
                            if (res.data.error==0) {
                               this.proList=res.data.data.list;
                            }
                        });
            }
        }
    }
</script>
<style lang="less" scoped>
.main {
    background: #fbfbfb;
    .main_footer {
        width: 100%;
        height: 50px;
        background: #fff;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99;
        .footer_btn {
            background: #36B374;
            color: #fff;
            font-size: 14px;
            height: 40px;
            width: 93%;
            border-radius: 5px;
            text-align: center;
            line-height: 40px;
        }
    }
}
</style>
